<adv-growl></adv-growl>
<p-panel>
    <p-header>
        <label i18n="@@labelText40">Ativos</label>
    </p-header>
    <p-table [value]="ativos"
             [columns]="cols"
             selectionMode="single"
             [(selection)]="selectedAtivo"
             [responsive]="true">

            <ng-template pTemplate="caption">
                <div style="text-align: right">
                    <i class="fa fa-eraser" i18n-title title="limpar" (click)="clearGridAtivos()" style="margin:4px 75% 4px 4px"></i>
                    <i class="fa fa-search" i18n-title title="buscar" (click)="findByAtivos()" style="margin:4px 4px 0 0"></i>
                    <input type="text" pInputText i18n-placeholder placeholder="Buscar por Ativo..." [(ngModel)]="filterAtivo" style="width:auto">
                  <button pButton type="button" label="Buscar por QR Code" (click)="displayModal = true"></button>
                </div>
            </ng-template>

            <ng-template pTemplate="header" let-columns>
                <tr class="ui-g">
                    <th class="ui-g-3" *ngFor="let col of columns">
                      <label>{{col.header}}</label>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr class="ui-g"
                    [pSelectableRow]="rowData"
                    (click)=selecionarAtivo(rowData)>

                    <td class="ui-g-3" *ngFor="let col of columns">
                        {{rowData[col.field]}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
</p-panel>

<p-dialog header="Aviso" [(visible)]="displayModal" [style]="{width: '350px', minWidth: '200px'}" [minY]="70">
  <p i18n="@@labelText83">Antes de enviar sua foto, tenha certeza que seu QR Code está centralizado.</p>
  <p-footer>
    <button type="button" pButton icon="pi pi-check" (click)="buscarQRCode()" label="OK"></button>
  </p-footer>
</p-dialog>
